/* istanbul ignore file: we do not need to care about the entry point file as errors are detected through integration tests (E2E) */

/**
 * The entry point for the admin side wp-admin resource.
 */
import { render } from "react-dom";
import { message, ConfigProvider, Avatar, Card, Form, Space } from "antd";
import "./style/antd.less";
import { listenHashPluginUpdate, listenPluginDeactivation, listenPluginUpdateLinkClick } from "./others";
import { PluginUpdateModal, Provider } from "./components";
import { ready } from "./utils"; // Configure prefix for root (https://bit.ly/3wb2pv9)

ConfigProvider.config({
  prefixCls: process.env.ANTD_PREFIX
});
message.config({
  top: 50
});
listenPluginDeactivation();
ready(() => {
  // Create main component for all available features (e.g. license modal)
  const node = document.createElement("div");
  document.body.appendChild(node);
  render( /*#__PURE__*/React.createElement(Provider, null, /*#__PURE__*/React.createElement(PluginUpdateModal, null)), node);
  listenPluginUpdateLinkClick();
  listenHashPluginUpdate();
});
export * from "./others";
export * from "./components";
export * from "./wp-api";
export * from "./store"; // Provide some UI elements so other plugins can use the same antd class prefix e.g. extending the update modal form
// Currently only used for Real Media Library as it does not yet use an own class prefix

export { Avatar, Card, Form, Space };